module.exports = __webpack_public_path__ + "img/banner3.8cb8c869.jpg";